<script lang="ts">
    import { onMount, getContext } from "svelte";
    import Hydrator from "@reperio-news/core.components/Hydrator.svelte";
    import ImageView from "@reperio-news/core.components/ImageView.svelte";

    export let content: any = undefined;
    export let isEditionArticle: any = undefined;
    export let category: number = undefined;

    const context: SvelteStore<any> = getContext("context");
    let buyEdition = null;

    let alreadyAdvertised = false;

    if (!category) {
        category = $context.domain_config.MISC.reviste_category_id;
    }

    if (content !== undefined) {
        for (const x of content?.body?.blocks || []) {
            if (
                x.type === "image" &&
                x.data.link?.href &&
                x.data.link.href.indexOf("paydemic") !== -1
            ) {
                alreadyAdvertised = true;
                break;
            }
        }
    }

    if (!alreadyAdvertised && content?.tags) {
        for (const tag of content.tags) {
            if (tag.indexOf("revista:") !== -1) {
                isEditionArticle = tag;
                break;
            }
        }
    }

    onMount(async () => {
        const q = {
            category,
            search_text: isEditionArticle
                .replace("revista:", "nr ")
                .split("/")
                .join(" "),
        };

        const res = await fetch(
            `/content.json?query_json=${encodeURIComponent(JSON.stringify(q))}`,
            {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );

        const { items } = await res.json();
        buyEdition = items.pop();
    });
</script>

{#if isEditionArticle && !alreadyAdvertised}
    <Hydrator
        component="BuyEdition"
        props={{
            isEditionArticle,
            category,
        }}
        hydrate={true}
    >
        {#if buyEdition && buyEdition.custom_fields?.buy_url}
            <a
                data-edition={buyEdition.custom_fields.buy_url}
                class="buy-edition"
                href={buyEdition.custom_fields.buy_url}
                target="_blank"
            >
                {#if buyEdition.poster}
                    <div class="image">
                        <ImageView
                            src={buyEdition.poster}
                            width={100}
                            height={300}
                            fit="contain"
                        />
                    </div>
                {/if}

                <div class="title">
                    <span> Cumpără ediția:</span>
                    <span class="value">{buyEdition.title}</span>
                </div>
            </a>
        {/if}
    </Hydrator>
{/if}

<style lang="scss">
    .buy-edition {
        display: flex;
        width: calc(100% - 20px);
        margin: auto;

        background-color: rgb(242, 243, 227);
        padding: 10px;
        justify-content: center;
        align-items: center;
        color: rgb(0, 0, 0);
        box-shadow: 5px 5px 21px 5px rgba(0, 0, 0, 0.34);

        .title {
            font-size: 20px;
            .value {
                font-weight: bold;
            }
        }

        span {
            margin-right: 10px;
        }

        .image {
            margin-right: 10px;
            object-fit: contain;
            width: 150px;
        }
    }

    .buy-edition:hover {
        background-color: rgb(205, 216, 167);
        transition: background-color 0.3s ease;
    }
</style>
